import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ToolPageHeader from './components/ToolPageHeader.vue'
import { getAppConfig, getCurrentUser } from './api/account'
import { ACCESS_TOKEN_KEY, AUTH_CONFIG } from './config/auth'

const legacyJsonInput = document.getElementById('fb-json-legacy-input')
if (legacyJsonInput) {
  const captureLegacyJsonInput = () => {
    if (!legacyJsonInput.value) return
    try {
      sessionStorage.setItem('fb-json-legacy-payload', legacyJsonInput.value)
    } catch (error) {
      // The hidden input still carries the value while this document is open.
    }
    window.dispatchEvent(new Event('fb-json-legacy-input'))
  }
  legacyJsonInput.addEventListener('input', captureLegacyJsonInput)
  captureLegacyJsonInput()
}

let remoteForceLogin = AUTH_CONFIG.forceLogin
let appConfigLoaded = false

async function loadAppConfig() {
  if (appConfigLoaded) return

  try {
    const response = await getAppConfig()
    if (response?.resultCode === '00000' && [0, 1].includes(response?.data?.forceLogin)) {
      remoteForceLogin = response.data.forceLogin === 1
    }
  } catch (error) {
    remoteForceLogin = AUTH_CONFIG.forceLogin
  } finally {
    appConfigLoaded = true
  }
}
// import {
//   // component
//   NButton,

//   // create naive ui
//   create
// } from 'naive-ui'

// const naive = create({
//   components: [NButton]
// })

import naive from 'naive-ui'

if (process.env.NODE_ENV === 'development') {
  window.addEventListener('error', event => {
    if (event.message === 'ResizeObserver loop completed with undelivered notifications.') {
      event.stopImmediatePropagation();
    }
  });
}


router.beforeEach(async (to, form, next) => {
  if(to.meta.title){
      document.title=to.meta.title;
  }

  const routeForceLogin = to.meta.forceLogin
  if (typeof routeForceLogin !== 'boolean') await loadAppConfig()

  const forceLogin = routeForceLogin ?? remoteForceLogin
  if (!forceLogin) {
    next()
    return
  }

  const token = localStorage.getItem(ACCESS_TOKEN_KEY)
  if (!token) {
    next({ name: 'login', query: { redirect: to.fullPath } })
    return
  }

  try {
    await getCurrentUser(token)
    next()
  } catch (error) {
    localStorage.removeItem(ACCESS_TOKEN_KEY)
    next({ name: 'login', query: { redirect: to.fullPath } })
  }
})

createApp(App)
.component('ToolPageHeader', ToolPageHeader)
.use(router)
.use(naive)
.mount('#app');
